import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, forkJoin, map, merge, Observable, of, startWith, switchMap } from 'rxjs';
import { DealService } from 'src/app/private/services/deals.service';
import { PipeLineService } from 'src/app/private/services/pipeline.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { applyCenterScopeToWhere } from 'src/app/utils/tenant-scope.util';

@Component({
  selector: 'app-deals',
  templateUrl: './deals.component.html',
  styleUrls: ['./deals.component.scss']
})
export class DealsComponent implements AfterViewInit {

  searchQuery = new FormControl();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  dateQuery = new FormControl();
  center_id: any;
  totalRows = 0;
  temp: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction = 'Add';
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  btnLoading: boolean = false;
  reloading: boolean = false;
  initialLoad: boolean = false;
  loading: boolean = true;
  closeResult = '';
  editData: any;
  deleteData: any;
  users: any = [];
  currencyCode: any;
  pipelines: any = [];
  pipelineData: any = [];
  importColumnsArray: any = [
    { key: 'deal_name', value: 'Deal Name' },
    { key: 'account_name', value: 'Account Name' },
    { key: 'lead_source', value: 'Lead Source' },
    { key: 'amount', value: 'Amount' },
    { key: 'description', value: 'Description' },
    { key: 'close_date', value: 'Close Date' },
    { key: 'probability', value: 'Probability' },
    { key: 'deal_stage', value: 'Deal Stage' },
    { key: 'deal_priority', value: 'Deal Priority' },
    { key: 'pipeline', value: 'Pipeline' },
    { key: 'next_step', value: 'Next Step' },
    { key: 'deal_type', value: 'Deal Type' },
  ];

  current_id_hover = '';
  infoArray: any = [];
  isToggled: boolean = false;
  isSaving: boolean = false;

  /** First page from bootstrap — consumed once by loadData() to avoid a duplicate getAllDeal. */
  private initialDealBootstrapResponse: any = null;
  private consumeInitialDealBootstrap = false;
  private sortDealPageResetBound = false;

  isAdmin: boolean = false;

  displayedColumns: string[] = [
    "deal_name",
    "info",
    "amount",
    "deal_owner",
    "lead_source",
    "account_name",
    "close_date",
    "probability",
    "deal_stage",
    "deal_type",
    "deal_priority",
    "action"
  ];

  displayedLebel: Record<string, string> = {
    deal_name: 'Deal Name',
    info: 'Info',
    amount: 'Amount',
    deal_owner: 'Deal Owner',
    lead_source: 'Lead Source',
    client_name: 'Contact Name',
    account_name: 'Account Name',
    close_date: 'Close Date',
    probability: 'Probability %',
    deal_stage: 'Deal Stage',
    deal_type: 'Deal Type',
    deal_priority: 'Priority',
    pipeline: 'Pipeline',
    next_step: 'Next Step',
    action: 'Action',
  };

  columnWidths: Record<string, string> = {
    deal_name: '140px',
    info: '5%',
    amount: '8%',
    deal_owner: '10%',
    lead_source: '10%',
    account_name: '11%',
    close_date: '9%',
    probability: '10%',
    deal_stage: '10%',
    deal_type: '9%',
    deal_priority: '8%',
    pipeline: '10%',
    client_name: '11%',
    next_step: '11%',
    action: '72px',
  };
  defaultFilter = [
    "deal_name",
    "deal_stage",
    "amount",
    "lead_source",
    "client_name",
    "account_name",
    "close_date",
    "priority",
    "probability",
    "deal_priority",
    "next_step",
    "pipeline",
  ]

  info = [
    { key: 'deal_name', value: 'Deal Name' },
    { key: 'account_name', value: 'Account Name' },
    { key: 'deal_stage', value: 'Deal Stage' },
    { key: 'amount', value: 'Amount' },
    { key: 'description', value: 'Description' },
    { key: 'lead_source', value: 'Lead Source' },
    { key: 'close_date', value: 'Close Date' },
    { key: 'probability', value: 'Probability' },
    { key: 'deal_type', value: 'Deal Type' },
    { key: 'Owner', value: 'Deal Owner' },
    { key: 'deal_priority', value: 'Deal Priority' },
    { key: 'next_step', value: 'Next Step' },
    { key: 'pipeline', value: 'Pipeline' },
    { key: 'createdAt', value: 'Created At' },
  ];

  constructor(
    private localStorage: LocalStorageService,
    private api: DealService,
    private pipelineApi: PipeLineService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private userApi: UsersService,
    private tracker: TrackingService
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  handleShowCanban(event: any) {
    this.isToggled = event;
  }

  ngOnInit(): void {
    this.getAllUsers();
    this.infoArray = this.info.map((item: any) => ({ key: item.key, value: item.value }));
  }

  ngAfterViewInit(): void {
    const storedCurrency = this.localStorage.getClientCurrency();
    this.currencyCode =
      storedCurrency && storedCurrency !== 'undefined' && storedCurrency !== 'null'
        ? storedCurrency
        : 'INR';
    this.bootstrapDealModule();
  }

  private fetchDealsListPage$(): Observable<any> {
    const param: any = {
      page: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      where: applyCenterScopeToWhere(
        { client_id: this.localStorage.getClientId() },
        this.localStorage
      ),
      order: { col: '"deal"."updatedAt"', dir: 'DESC' },
    };

    if (this.searchQuery.value) {
      for (let [key, value] of Object.entries(this.searchQuery.value)) {
        if (this.defaultFilter.includes(key)) {
          key = key === 'assign_to' ? 'assign_to' : key;
          param.filter = { ...param.filter, [key]: value };
        }
      }
    }

    if (!this.isAdmin) {
      param.where.deal_owner = this.localStorage.getUserId();
    }

    return this.api.getAllDeal(param).pipe(catchError(() => of(null)));
  }

  private bootstrapDealModule(): void {
    this.loading = true;
    const pipelines$ = this.pipelineApi
      .getAllPipeLine({ client_id: this.localStorage.getClientId(), pipeline_type: 'deal' })
      .pipe(catchError(() => of([])));

    const rows$ = this.fetchDealsListPage$().pipe(
      map((response: any) => {
        if (response === null) return { rows: [], count: 0 };
        return { rows: response?.rows ?? [], count: response?.count ?? 0 };
      }),
      catchError(() => of({ rows: [], count: 0 }))
    );

    forkJoin({ rows: rows$, pipelines: pipelines$ })
      .pipe(
        catchError(() =>
          of({ rows: { rows: [], count: 0 }, pipelines: [] as any[] })
        )
      )
      .subscribe({
        next: ({ rows, pipelines }) => {
          const pData = Array.isArray(pipelines) ? pipelines : [];
          this.pipelineData = pData;
          this.pipelines = pData.map((item: any) => item.pipeline_name);

          this.totalRows = rows.count ?? 0;
          this.dataSource = new MatTableDataSource<any>(rows.rows ?? []);
          this.initialLoad = false;
          this.loading = false;
          this.reloading = false;

          this.initialDealBootstrapResponse = rows;
          this.consumeInitialDealBootstrap = true;
          this.loadData();
        },
        error: (e) => {
          this.initialLoad = false;
          this.loading = false;
          this.reloading = false;
          this.toast.error('Something went wrong, please refresh the page');
          console.error(e);
        },
      });
  }

  getAllPipeline() {
    this.pipelineApi
      .getAllPipeLine({ client_id: this.localStorage.getClientId(), pipeline_type: 'deal' })
      .subscribe({
        next: (res: any) => {
          this.pipelineData = res || [];
          this.pipelines = this.pipelineData.map((item: any) => item.pipeline_name);
        },
        error: (e: any) => console.error(e),
      });
  }


  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }


  open(content: any) {
    this.formAction = 'Add';

    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }

  loadData() {
    try {
      if (!this.sortDealPageResetBound && this.sort) {
        this.sortDealPageResetBound = true;
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            if (this.consumeInitialDealBootstrap && this.initialDealBootstrapResponse != null) {
              this.consumeInitialDealBootstrap = false;
              const cached = this.initialDealBootstrapResponse;
              this.initialDealBootstrapResponse = null;
              return of(cached);
            }
            this.reloading = true;
            return this.fetchDealsListPage$();
          }),
          map((response: any) => {
            this.initialLoad = false;
            this.loading = false;
            this.reloading = false;
            if (response === null) {
              this.totalRows = 0;
              return [];
            }
            this.totalRows = response.count ?? 0;
            return response?.rows ?? [];
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.loading = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.loading = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.loading = false;
      this.reloading = false;
      console.error(e);
    }
  }

  reloadData() {
    this.reloading = true;
    this.paginator.pageIndex = 0;
    this.fetchDealsListPage$()
      .pipe(
        map((response: any) => {
          if (response === null) return { rows: [], count: 0 };
          return { rows: response?.rows ?? [], count: response?.count ?? 0 };
        })
      )
      .subscribe({
        next: ({ rows, count }) => {
          this.totalRows = count;
          this.dataSource = new MatTableDataSource<any>(rows);
          this.initialLoad = false;
          this.loading = false;
          this.reloading = false;
        },
        error: (e) => {
          this.initialLoad = false;
          this.loading = false;
          this.reloading = false;
          console.error(e);
        },
      });
  }

  openEdit(content: any, data: any) {
    this.formAction = 'Update';
    this.editData = data;
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }

  openDeleteEvent(content: any, data: any) {
    this.deleteData = data;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    })
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
  }

  handleDeleteCompany() {

    const parmas = {
      "deal_id": this.deleteData.deal_id
    }
    this.btnLoading = true;
    this.api.deleteDeal(parmas).subscribe((res: any) => {
      console.log('Response:', res);
      this.toast.success('Company Deleted Successfully');

      const desc = `Deal deleted with name: ${this.deleteData.deal_name} and deal id: ${this.deleteData.deal_id}`;
      this.tracker.track("Delete", "Deal", desc); // ✅ Track Delete
      this.reloadData();
      this.btnLoading = false;
      this.modalService.dismissAll();
    })
  }

  updateHoverState(id: string): void {
    this.current_id_hover = id;
  }

  getCellValue(element: any, column: string): string {
    switch (column) {
      case 'deal_name':
        return element.deal_name || 'N/A';
      case 'deal_owner': {
        const owner = [element.dealOwner?.fname, element.dealOwner?.lname]
          .filter(Boolean)
          .join(' ')
          .trim();
        return owner || 'N/A';
      }
      case 'lead_source':
        return element.lead_source || 'N/A';
      case 'client_name': {
        const contact = [element.contact?.first_name, element.contact?.last_name]
          .filter(Boolean)
          .join(' ')
          .trim();
        return contact || 'N/A';
      }
      case 'account_name':
        return element.account?.account_name || 'N/A';
      case 'probability':
        if (element.probability === 0 || element.probability) {
          return String(element.probability);
        }
        return 'N/A';
      case 'deal_stage':
        return element.deal_stage || 'N/A';
      case 'deal_type':
        return element.deal_type || 'N/A';
      case 'pipeline':
        return element.pipeline || 'N/A';
      case 'next_step':
        return element.next_step || 'N/A';
      default:
        return element[column] ?? 'N/A';
    }
  }

  getDealPriorityClass(priority: string): string {
    const normalized = String(priority || '').toLowerCase();
    if (normalized === 'high') {
      return 'hot_lead';
    }
    if (normalized === 'low') {
      return 'cold_lead';
    }
    if (normalized === 'medium') {
      return 'new_lead';
    }
    return 'new_lead';
  }

  isSortableColumn(column: string): boolean {
    return column !== 'info' && column !== 'action';
  }

  getColumnWidth(column: string): string {
    return this.columnWidths[column] || '8%';
  }

  getColumnClasses(column: string): Record<string, boolean> {
    return {
      'deals-col--deal-name': column === 'deal_name',
      'deals-col--info': column === 'info',
      'deals-col--center': column === 'info' || column === 'action',
    };
  }

  updateStatus(data: any) {
    console.log('Update Status:', data);
    this.isSaving = true;


    this.api.updateDeal(data).subscribe({
      next: (res: any) => {
        console.log('Response:', res);
        // this.toast.success('Deal Updated Successfully');
      },
      error: (err: any) => {
        console.error('Error updating deal:', err);
        this.toast.error('Failed to update the deal. Please try again.');
      },
      complete: () => {
        this.isSaving = false; // Ensure it's set to false regardless of success or failure
      }
    });
  }



}

